/**
 * eMuseum URL'lerine güvenli query parametresi ekler.
 * `undefined` string'i veya boş params ile kirli URL üretimini engeller.
 */
export function appendEmuseumQueryParams(
  baseUrl: string,
  params?: string | null
): string {
  const trimmed = (params ?? '').trim()
  if (!trimmed || trimmed === 'undefined') {
    return baseUrl
  }
  const separator = baseUrl.includes('?') ? '&' : '?'
  return `${baseUrl}${separator}${trimmed}`
}
